
export const UI_IS_XS = window.matchMedia('(max-width: 575.98px)');
export const UI_IS_SM = window.matchMedia('(max-width: 767.98px)');
export const UI_IS_MD = window.matchMedia('(max-width: 991.98px)');
export const UI_IS_LG = window.matchMedia('(max-width: 1199.98px)');
